import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = [{
    title: 'Contenido 100% argentino',
    desc: 'Minerales, rocas, volcanes, sismos y recursos del territorio nacional'
  }, {
    title: 'Material imprimible',
    desc: 'Listo para usar en el aula o entregar al alumno'
  }, {
    title: 'Fichas de referencia rápida',
    desc: 'Para consultar mientras enseñás'
  }, {
    title: 'Ejemplos aplicados',
    desc: 'Vaca Muerta, litio de la Puna, Perito Moreno, Ischigualasto'
  }, {
    title: 'Vocabulario técnico explicado',
    desc: 'Sin tecnicismos innecesarios para el aula'
  }, {
    title: 'Conexión con la actualidad',
    desc: 'Litio, shale, riesgo sísmico, cambio climático'
  }, {
    title: '4 Bonos estratégicos',
    desc: 'Actividades, imágenes, evaluaciones y presentaciones'
  }, {
    title: 'Garantía de 7 días',
    desc: 'Sin preguntas ni formularios'
  }, {
    title: 'Acceso inmediato',
    desc: 'Descarga directa tras la compra'
  }, {
    title: 'Actualizaciones gratuitas',
    desc: 'Acceso de por vida al material'
  }, {
    title: 'Casos reales argentinos',
    desc: 'Terremoto de San Juan, Acuífero Guaraní y más'
  }, {
    title: 'Guías de salida de campo',
    desc: 'Para aprovechar el entorno geológico'
  }];
  return <section className="py-14 bg-[#f5efe1] border-y border-[#d3c8ac]" data-id="element-150">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-151">
        <h3 className="text-2xl font-black text-center mb-10 text-[#1e4230] font-[Merriweather,_serif]" data-id="element-152">
          ✅ TODOS LOS TOMOS INCLUYEN
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-153">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg bg-white border border-[#e0d6bf] hover:border-[#c8971b]/50 transition-colors" data-id="element-154">
              <CheckCircle2 className="w-5 h-5 text-[#2f6b47] shrink-0 mt-0.5" data-id="element-155" />
              <div data-id="element-156">
                <span className="text-[#1e4230] font-bold text-[15px] block" data-id="element-157">
                  {item.title}
                </span>
                <span className="text-[#6f4e2e] text-sm" data-id="element-158">{item.desc}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}